import React from "react";
import Icons from "../../../../config/images";
import "./heroSection.css";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <div className="hero-section-main-black-container">
      {/* <Header /> */}

      <div className="hero">
        {/* Left Content */}
        <div className="hero-section-hero-content">
          <h1 className="seo-hidden">
            Jewellery Website Development Company in Ahmedabad | BA Code
            Solutions
          </h1>

          <h1 className="hero-h1">
            <span>
              {" "}
              We Build Digital Products <br /> That Power{" "}
            </span>
            Your Jewellery Business
          </h1>

          <p className="hero-subheading">
            Custom Web & Mobile App Solutions Designed for Jewellery Brands,
            Retailers & Manufacturers
          </p>

          <p className="hero-paragraph">
            <span>|</span> GOLD <span>|</span> DIAMOND <span>|</span> SILVER{" "}
            <span>|</span> PLATINUM <span>|</span> ERP <span>|</span> E-COMMERCE
          </p>

          <p className="hero-description">
            At BA Code Solution, we specialize in building secure, scalable and
            high-performance web & mobile applications tailored specifically for
            the jewellery industry.
          </p>

          <div
            className="contact-us-btn"
            onClick={() => navigate("/contact-us")}
          >
            Talk to Our Experts
          </div>
        </div>

        {/* Right Image */}
        <div className="hero-image-container">
          <img
            src={Icons.homeImage}
            alt="Jewellery App"
            className="hero-image"
          />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
